export default () => ({
  isShow: false,
  showModal: false,
  isShowPrice: false,
  isShowProfile: false
})



// WEBPACK FOOTER //
// ./src/app/patient/profile-company/components/Items/resources/data.js